module.exports = __webpack_public_path__ + "static/media/fpt.16c8e446.svg";